export const openNewPage = url => window.open(url, '_blank');
export const redirectToPage = url => (window.location.href = url);
